<template>
  <p class="empty-state">{{ emptyText }}</p>
</template>

<style scoped>
.empty-state {
  margin: 0;
  color: var(--kate-type-alt);
  font-size: 0.95rem;
}
</style>

<script>
export default {
  props: {
    emptyText: {
      type: String,
      default: 'No items in this section',
    },
  },
};
</script>
